module.exports = __webpack_public_path__ + "static/media/5.21d843d2.JPG";